import { TextLinkWidget } from '@tableau/widgets';
import { BodyCell } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { StyledCellFormatter } from '~src/app/spaces/ListView/StyledCellWrapper';
import { Messages } from '~src/codegen/Localize';
import { RunFlowTaskInfo } from '~src/ts/models/RunFlowTaskInfo';

import { getAndOpenLinkedTaskDetailsDialog } from './LinkedTaskDetailsDialog';

export function LinkedTaskWithCountCell(): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function LinkedTaskWithCountCell(props: BodyCell.Props) {
        const row = props.row;
        const data = row.data as RunFlowTaskInfo;

        function handleLinkedTaskWithCountClick() {
          getAndOpenLinkedTaskDetailsDialog(data.linkedTaskId);
        }

        return(
          <TextLinkWidget
            testId={'FlowScheduleTypeCellTextLinkButton'}
            onClick={handleLinkedTaskWithCountClick}
            style={{fontWeight: 'normal'}}
          >
            {Messages.linkedTasksWithCount({TOTAL_COUNT_LOC: data.totalSteps.toString()})}
          </TextLinkWidget>
        );
      }
  );
}
